document.querySelectorAll('.product-sample-request').forEach((element) => {
  element.querySelectorAll('input, textarea').forEach((input) => input.addEventListener('blur', () => markAsDirty(input)));
  element.addEventListener('invalid', (event) => {
      markAsDirty(event.target);
      event.preventDefault();
    },
    true
  );

  function markAsDirty(input) {
    if (input.type !== 'radio') {
      markSingleElementAsDirty(input);
      return;
    }
    input.parentElement.parentElement.querySelectorAll('input').forEach((radio) => markSingleElementAsDirty(radio));
  }

  function markSingleElementAsDirty(input) {
    const { classList } = input;
    if (classList.contains('dirty')) {
      return;
    }
    classList.add('dirty');
    validate(input);
    input.addEventListener('input', () => validate(input));
  }

  function validate(input) {
    const { validity, style, type } = input;
    let { parentElement } = input;
    if (type === 'radio') {
      parentElement = parentElement.parentElement;
    }
    parentElement.querySelector('.error-message')?.remove();
    const inputs = parentElement.querySelectorAll('input, textarea');
    if (validity.valid) {
      inputs.forEach((input) => {
        const { style } = input;
        style.border = '';
        style.boxShadow = '';
      });
      return;
    }
    let message;
    switch (type) {
      case 'radio':
        inputs.forEach((radio) => (radio.style.boxShadow = '0 0 0 1px #DC3545'));
        message = 'Bitte wähle eine dieser Optionen aus';
        break;
      case 'checkbox':
        style.boxShadow = '0 0 0 1px #DC3545';
        message = 'Bitte aktiviere dieses Kontrollkästchen, um fortzufahren';
        break;
      default:
        style.border = '1px solid #DC3545';
        if (validity.valueMissing) {
          message = 'Bitte fülle dieses Feld aus';
          break;
        }
        if (input.name === 'zip_code') {
          message = 'Bitte 5 Ziffern eingeben';
          break;
        }
        message = 'Bitte Schreibweise/Sonderzeichen beachten';
    }
    const errorMessageDiv = document.createElement('strong');
    const errorMessageIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    const errorMessageIconUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');

    errorMessageIconUse.setAttribute('href', '/assets/iconset.svg#warning-24');

    errorMessageIcon.setAttribute('width', '16');
    errorMessageIcon.setAttribute('height', '16');
    errorMessageIcon.setAttribute('data-size', '16');

    errorMessageIcon.append(errorMessageIconUse);

    errorMessageDiv.classList.add('error-message', 'text-danger', 'd-block', 'mt-1');
    errorMessageDiv.setAttribute('role', 'alert');
    errorMessageDiv.textContent = message;
    errorMessageDiv.prepend(errorMessageIcon);
    parentElement.append(errorMessageDiv);
  }
});
